<template>
  <div class="form-select-drawer">
    <div v-if="showDrawer" class="form-select-drawer-mask"></div>
    <cube-drawer
      ref="drawer"
      class="select-drawer"
      :visible="true"
      :class="showDrawer ? 'show-drawer' : 'hide-drawer'"
      @click.native.prevent="cancel"
    >
      <div slot="title" class="title">
        <span class="cancel" @click="cancel">取消</span>
        <span class="content">{{ widget.label }}</span>
        <span class="ok" @click="okEvent">确定</span>
      </div>
      <div class="select-body">
        <template v-if="widget.chooseType === 'MULTI'">
          <cube-checkbox-group v-model="formValueData">
            <template v-for="(option, index) in chooseOptions">
              <cube-checkbox :key="index" :option="{ value: option.id, disabled: widget.readOnly }">
                <div class="checkbox-box">
                  <x-svg-icon
                    v-if="formValueData && formValueData.includes(option.id)"
                    class="checkbox-svg-ui active"
                    :class="widget.readOnly ? 'disable' : ''"
                    name="x-lib-checkbox-active"
                  ></x-svg-icon>
                  <x-svg-icon v-else class="checkbox-svg-ui" name="x-lib-checkbox"></x-svg-icon>
                  <div
                    class="checkbox-tag"
                    :style="{
                      'background-color': widget.multicolor ? option.color : '#FFFFFF',
                      color: widget.multicolor ? '#FFFFFF' : '#303133',
                      margin: widget.multicolor ? '' : 0
                    }"
                  >
                    <span>{{ option.label }}</span>
                  </div>
                </div>
              </cube-checkbox>
            </template>
          </cube-checkbox-group>
        </template>
        <template v-else>
          <cube-radio-group>
            <cube-radio
              v-for="(option, index) in chooseOptions"
              class="form-radio-choose"
              :key="index"
              :option="option"
              v-model="formValueRadio"
              @click.native.prevent="getRadioStatus(option)"
            >
              <div class="radio-box">
                <x-svg-icon
                  v-if="formValueRadio === option.id"
                  class="radio-svg-ui active"
                  :class="widget.readOnly ? 'disable' : ''"
                  name="x-lib-radio-active"
                ></x-svg-icon>
                <x-svg-icon v-else class="radio-svg-ui" name="x-lib-radio"></x-svg-icon>
                <div
                  class="radio-tag"
                  :style="{
                    'background-color': widget.multicolor ? option.color : '#FFFFFF',
                    color: widget.multicolor ? '#FFFFFF' : '#303133',
                    margin: widget.multicolor ? '' : 0
                  }"
                >
                  <span>{{ option.label }}</span>
                </div>
              </div>
            </cube-radio>
          </cube-radio-group>
        </template>
      </div>
    </cube-drawer>
  </div>
</template>

<script>
import FormValueTag from '../form-value-tag/form-value-tag'
export default {
  components: {
    FormValueTag
  },
  data() {
    return {
      showDrawer: false,
      formValueData: [],
      visible: false
    }
  },
  props: {
    chooseOptions: {
      type: Array,
      default: function() {
        return []
      }
    },
    widget: {
      type: Object,
      default: function() {
        return {}
      }
    }
  },
  computed: {
    formValueRadio: {
      get() {
        if (this.formValueData instanceof Array) {
          if (this.formValueData.length > 0) {
            return this.formValueData[0]
          } else {
            return ''
          }
        } else {
          return this.formValueData || ''
        }
      },
      set(value) {
        if (value) {
          this.formValueData = [value]
        } else {
          this.formValueData = null
        }
      }
    }
  },
  mounted() {
    window.addEventListener('popstate', this.cancel, false)
  },
  destroyed() {
    window.removeEventListener('popstate', this.cancel, false)
  },
  methods: {
    open(data) {
      document.body.appendChild(this.$el)
      this.showDrawer = true
      if (data) {
        this.formValueData = data.filter((id) => {
          let idTag = null
          this.chooseOptions.forEach((item) => {
            if (id === item.id) {
              idTag = id
            }
          })
          if (idTag) {
            return idTag
          }
        })
      } else {
        this.formValueData = []
      }
    },
    cancel() {
      this.showDrawer = false
    },
    okEvent() {
      this.showDrawer = false
      console.log(this.formValueData)
      this.$emit('okEvent', this.formValueData)
    },
    getRadioStatus(data) {
      data.id === this.formValueData ? (this.formValueData = '') : (this.formValueData = data.id)
    }
  }
}
</script>

<style lang="scss">
.form-select-drawer {
  z-index: 1000;

  .form-select-drawer-mask {
    background-color: rgba(0, 0, 0, 0.3);
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 200;
  }

  .select-drawer {
    z-index: 200;
    top: 100vh;
    position: fixed;
    // display: none;

    .cube-drawer-main {
      position: absolute;
      // box-shadow: 0px -1px 5px $--app-base-font-color;
      left: 0;
      right: 0;
      width: 100vw;
      top: 60%;
      max-width: 100%;
      bottom: 0;

      .cube-drawer-title {
        z-index: 10;
        .title {
          display: flex;
          justify-content: space-between;
          font-size: $--app-title-font-size;
        }
        .content {
          overflow: hidden;
          text-overflow: ellipsis;
          white-space: nowrap;
        }
        .cancel {
          color: $--app-primary-color;
          min-width: 3rem;
        }
        .ok {
          color: $--app-primary-color;
          min-width: 3rem;
        }
      }

      .cube-drawer-panels {
        background-color: $--app-light-color;
      }
    }
  }
  .show-drawer {
    top: 0 !important;
    transition: top 0.3s ease;
    overflow: scroll;
    // animation-name: drawerTraUp;
    // animation-duration: .3s;
    // animation-timing-function: ease;
    // animation-fill-mode: forwards;
  }
  .hide-drawer {
    top: 100vh !important;
    transition: top 0.3s ease;
    // animation-name: drawerTraDown;
    // animation-duration: .3s;
    // animation-timing-function: ease;
    // animation-fill-mode: forwards;
  }
  .select-body {
    width: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    // padding: 14px 0;
    box-sizing: border-box;
    position: absolute;
    top: 3.571rem;
    left: 0;
    bottom: 0;
    overflow: auto;
    .option-box {
      width: 100%;
      .select-read-tag-box {
        justify-content: center;
        .select-read-tag {
          margin-bottom: 1rem;
          margin-right: 0;
        }
      }
    }
    .checkbox-svg-ui {
      display: flex;
      align-items: center;
      color: $--app-notice-color;
      margin-left: -0.214rem;
      &.active {
        color: $--app-primary-color;
      }
    }
    .border-top-1px::before {
      border: 0;
    }
    .border-bottom-1px::after {
      border: 0;
    }
    .cube-checkbox-group {
      overflow: auto;
      width: 100%;
      .cube-checkbox-wrap {
        padding: .392857rem 0;
      }
      .cube-checkbox {
        padding: 0;
        min-height: 2.857rem;

        .cube-checkbox-label {
          width: 100%;
        }

        .cube-checkbox-ui {
          display: none;
        }
        .checkbox-box {
          display: flex;
          min-height: 2.857rem;
          align-items: center;
          padding-left: 20px;
          box-sizing: border-box;
          width: 100%;
          .checkbox-svg-ui {
            display: flex;
            align-items: center;
            color: $--app-notice-color;
            margin-left: -0.214rem;
            &.active {
              color: $--app-primary-color;
            }
          }
          .checkbox-tag {
            min-height: 1.714rem;
            display: flex;
            align-items: center;
            padding: .392857rem .786rem;
            margin: 0 0.715rem;
            border-radius: .857rem;
            max-width: 100%;

            span {
              // overflow: hidden;
              // text-overflow: ellipsis;
              // white-space: nowrap;
              width: 100%;
              line-height: 1.5;
              display: inline-block;
            }
          }
        }
      }
    }
    .cube-radio-group {
      width: 100%;
      overflow: auto;
      box-sizing: border-box;
      padding-left: 20px;
    }
    .border-top-1px::before {
      border: 0 !important;
    }
    .border-bottom-1px::after {
      border: 0;
    }
    .form-radio-choose {
      padding-right: 0 !important;
      // padding-left: 2.286rem !important;
      padding-left: 0;
      position: relative;
      min-height: 2.857rem;

      .cube-radio-wrap {
        padding: .392857rem 0;
      }

      .cube-radio-ui {
        opacity: 0;
        display: none;
      }

      .radio-box {
        display: flex;
        min-height: 2.857rem;
        align-items: center;
        // position: absolute;
        // left: -2.286rem;
        // top: 0;
        // width: calc(100% - 1.571rem);
        .radio-svg-ui {
          display: flex;
          align-items: center;
          color: $--app-notice-color;
          margin-left: -0.214rem;
          &.active {
            color: $--app-primary-color;
          }
        }
        .radio-tag {
          min-height: 1.714rem;
          display: flex;
          align-items: center;
          padding: .392857rem .786rem;
          margin: 0 0.715rem;
          border-radius: .857rem;
          max-width: 95%;

          span {
            // overflow: hidden;
            // text-overflow: ellipsis;
            // white-space: nowrap;
            width: 100%;
            line-height: 1.5;
            display: inline-block;
          }
        }
      }
    }
  }
}
@keyframes drawerTraUp {
  0% {
    display: block;
  }
  1% {
    top: 100vh;
  }
  100% {
    top: 0;
  }
}
@keyframes drawerTraDown {
  0% {
    top: 0;
  }
  95% {
    top: 100vh;
  }
  99% {
    display: none;
  }
  100% {
    top: 100vh;
  }
}
</style>
